module.exports = __webpack_public_path__ + "img/oxidative-stress.98ae8a90.svg";